import React, { useState, useEffect } from "react";
import { generatePlaceholderName } from "../utils/NameGenerator";
import QrScannerView from "./QrScannerView";
import bs58 from 'bs58';
import { addContact } from "../db/ContactStorage";
import { usePasswordAndUserId } from "../context/AuthContext";

export default function NewContactView({ 
  onBack, 
  onNewContact,
  contacts, 
  setContacts,
}) {
  const [viewKey, setViewKey] = useState("");
  const [alias, setAlias] = useState("");
  const [error, setError] = useState("");
  const [defaultAlias, setDefaultAlias] = useState("");
  const [scanning, setScanning] = useState(false);
  const { password, userId, salt } = usePasswordAndUserId(); 

  useEffect(() => {
    setDefaultAlias(generatePlaceholderName());
  }, []);

  const handleSave = async () => {
    if (viewKey.length !== 43 && viewKey.length !== 44) {
      setError("The Unlink Address must be exactly 43 or 44 characters long.");
      return;
    }

    let decodedKey;
    try {
      decodedKey = bs58.decode(viewKey);
    } catch (err) {
      console.error("Invalid Base58 input:", err);
      // Optionally show a user-friendly error message or return early
      alert("The view key you entered is invalid. Please check and try again.");
      return; // prevent the rest of the logic from executing
    }

    // Proceed only if decoding succeeded
    const updatedContacts = await addContact({
      identityViewPublicKey: decodedKey,
      name: alias.trim() || defaultAlias,
      userId, 
      password,
    });

    setContacts(updatedContacts);
    onNewContact();
  };

  const handleAliasKeyDown = (e) => {
    if (e.key === "Enter") handleSave();
  };

  return (
    <>
      {scanning ? (
        <QrScannerView
          onBack={() => setScanning(false)}
          onScanned={(value) => {
            setViewKey(value);
            setScanning(false);
          }}
        />
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100vh",
            backgroundColor: "#000",
            color: "#fff",
          }}
        >
          {/* Sticky Header */}
          <div
            style={{
              position: "sticky",
              top: 0,
              zIndex: 10,
              backgroundColor: "#000",
              borderBottom: "1px solid #222",
              padding: "1rem",
              display: "flex",
              alignItems: "center",
            }}
          >
            <button
              onClick={onBack}
              style={{
                color: "#fff",
                background: "none",
                border: "none",
                fontSize: "1.5rem",
                marginRight: "1rem",
                cursor: "pointer",
              }}
            >
              ←
            </button>
            <h2 style={{ margin: 0 }}>Add New Contact</h2>
          </div>

          {/* Scrollable Content */}
          <div
            style={{
              flex: 1,
              overflowY: "auto",
              padding: "1rem",
              boxSizing: "border-box",
            }}
          >
            <label style={{ marginBottom: "0.5rem", display: "block" }}>
              Unlink Address
            </label>
            <div style={{ position: "relative", width: "100%", marginBottom: "0.5rem" }}>
              <input
                type="text"
                value={viewKey}
                onChange={(e) => setViewKey(e.target.value)}
                placeholder="Paste or scan Unlink Address"
                style={{
                  width: "100%",
                  padding: "0.5rem 2.5rem 0.5rem 0.5rem",
                  borderRadius: "6px",
                  border: "none",
                  backgroundColor: "rgb(50 50 50)",
                  color: "#4e8cff",
                  boxSizing: "border-box",
                }}
              />
              <button
                onClick={() => setScanning(true)}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "0.5rem",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                }}
                aria-label="Scan QR"
              >
                <img
                  src="/images/qr-icon.png"
                  alt="Scan QR"
                  width="20"
                  height="20"
                  style={{ filter: "invert(1)" }}
                />
              </button>
            </div>

            <small style={{ display: "block", color: "#aaa", marginBottom: "1rem" }}>
              This is the public Unlink Address your contact has shared. It allows messages to be routed to them securely and privately.
            </small>

            <label style={{ marginBottom: "0.5rem", display: "block" }}>
              Alias (optional)
            </label>
            <input
              type="text"
              value={alias}
              onChange={(e) => setAlias(e.target.value)}
              onKeyDown={handleAliasKeyDown}
              placeholder={`E.g. ${defaultAlias}`}
              style={{
                width: "100%",
                padding: "0.5rem",
                marginBottom: "1rem",
                borderRadius: "6px",
                border: "none",
                backgroundColor: "rgb(50 50 50)",
                color: "#4e8cff",
              }}
            />

            {error && (
              <div style={{ color: "#f66", marginBottom: "1rem" }}>{error}</div>
            )}

            <button
              onClick={handleSave}
              style={{
                padding: "0.5rem 1rem",
                fontSize: "1rem",
                borderRadius: "4px",
                border: "none",
                backgroundColor: "#4e8cff",
                color: "white",
                cursor: "pointer",
              }}
            >
              Save Contact
            </button>
          </div>
        </div>
      )}
    </>
  );
}